<template>
  <v-carousel cycle height="auto">
    <v-carousel-item 
        v-for="(item, i) in items"
        :key="i"
        eager
    >
      <v-sheet height="100%">
        <a>
            <BaseImage 
                :mobileSrc="item.mobileSrc" 
                :desktopSrc="item.desktopSrc"
            />
        </a>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import BaseImage from "../../baseImage/components/BaseImage";
export default {
  name: 'BaseSlider',
  components: {BaseImage},
  props: {
      items: {
          type: Array,
      }
  },
};
</script>
